import { Typography } from '@speeki/global-ui-components';

import { ListItem, ListItemDescription } from './SingleIncidentType.styled';

interface SingleIncidentTypeProps {
    description: string;
    name: string;
    uuid: string;
}

export const SingleIncidentType = ({
    description,
    name,
    uuid,
}: SingleIncidentTypeProps) => {
    return (
        <ListItem key={uuid}>
            <Typography.TextBullet_16_22 fontWeight={'bold'}>
                {name}
            </Typography.TextBullet_16_22>
            <ListItemDescription>{description}</ListItemDescription>
        </ListItem>
    );
};
